import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import FixedItineraryPeriodicHikeServices from "services/FixedItineraryPeriodicHikeServices";
import { notifyError, notifySuccess } from "utils/toast";

const useFixedItineraryPeriodicHikeSubmit = (id) => {
  
  const { isDrawerOpen, closeDrawer, setIsUpdate } =
    useContext(SidebarContext);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedCity, setSelectedCity] = useState([]);
  const [dataInput, setDataInput] = useState([{"vehicle_type_0":"","hike_0":""}]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleStartDateChange = (event) => {
    const selectedStartDate = event;
    setStartDate(selectedStartDate);
    // setEndDate(selectedStartDate);
  };
  const handleVehicleCategoryChange = (e, index) => {
    const { name,value } = e.target;
    //selected value
    const onChangeVals = [...dataInput];
    onChangeVals[index][name] = value;
    setDataInput(onChangeVals);
    // selected options
    const updatedSelectedOptions = [...selectedOptions];
    updatedSelectedOptions[index] = value;
    setSelectedOptions(updatedSelectedOptions);
  };

  const {
    trigger,
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm();
  

  const handleCityChange = (city_id) => {
    setSelectedCity(city_id);
  };
  const handleChangeInput = (e, i) => {
    if(e&&e.target){
    const { name, value } = e.target;
    if(value === '0'){
      return;
    }
    const onChangeVal = [...dataInput];
    onChangeVal[i][name] = value;
    setDataInput(onChangeVal);
    }
  };
  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const dataValues={};
      const vehicleTypeValues=dataInput.map((item)=> parseInt(item[Object.keys(item)[0]]));
       const HikeValues = dataInput.reduce((accumulator, item) => {
        const key = item[Object.keys(item)[0]];
        const value = item[Object.keys(item)[1]];
        accumulator[key] = value;
        return accumulator;
      }, {});
      // const cityIds=[];
      // selectedCity.forEach((dataInput)=>{
      //     cityIds.push(dataInput.value);
      //   });
      const cityIds = selectedCity.map((state) => {
        if (typeof state === 'string') {
          return state; 
        }
        if (typeof state === 'object' && state.value) {
          return state.value;
        }
        return null;
      }).filter(Boolean); 

      dataValues.vehicle_type=vehicleTypeValues;
      dataValues.hike=HikeValues;
      dataValues.cities=cityIds.sort((a, b) => a - b);
      dataValues.start_date=startDate;
      dataValues.end_date=endDate;
      if(cityIds.length === 0){
        notifyError("State or City is required");
        return;
      }
      setIsSubmitting(true);
      if (id) {
        const res = await FixedItineraryPeriodicHikeServices.updateFixedItineraryPeriodicHike(id,dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      } else {
        const res = await FixedItineraryPeriodicHikeServices.addFixedItineraryPeriodicHike(dataValues);
        setIsUpdate(true);
        setIsSubmitting(false);
        notifySuccess(res.message);
        closeDrawer();
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
      setIsSubmitting(false);
    //  closeDrawer();
    }
    finally{
      setLoading(false);
    }
  };

  const getFixedItineraryPeriodicHikeData = async () => {
    try {
      const res = await FixedItineraryPeriodicHikeServices.getFixedItineraryPeriodicHikeById(id);
      if (res) {
        const FormWholeArray=[];
        if(res.vehicle_type_id){
          res.vehicle_type_id.forEach((item,index)=>{
            let obj={};
            obj['vehicle_type_'+index]=item; 
            obj['hike_'+index]=res['hike'][item]; 
            FormWholeArray.push(obj);
          });
        }
          // const cities=res.city_id.map((id,index)=>({
          //   value:Number(id),
          //   label:res.city_names[index]

          // }));
        setDataInput(FormWholeArray);
        setSelectedOptions(res.vehicle_type_id);
        setSelectedCity(res.city_id);
        setStartDate(new Date(res.start_date));
        setEndDate(new Date(res.end_date));   
      }
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  useEffect(() => {
    if (!isDrawerOpen) {
        setDataInput([{"vehicle_type_0":"","hike_0":""}]);
        setSelectedOptions([]);
        setSelectedCity([]);
        setStartDate('');
        setEndDate('');   
        clearErrors("start_date");
        clearErrors("end_date");
        clearErrors("cities");
        clearErrors(); 
  
      return;
    }
      
    if (id) {
      getFixedItineraryPeriodicHikeData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, setValue, isDrawerOpen, clearErrors]);


  return {
    register,
    handleSubmit,
    onSubmit,
    handleCityChange,
    selectedCity,
    trigger,
    errors,
    isSubmitting,
    handleVehicleCategoryChange,
    selectedOptions,
    setSelectedOptions,
    setDataInput,
    dataInput,
    handleChangeInput,
    setStartDate,
    startDate,
    handleStartDateChange,
    setEndDate,
    endDate,
    loading,setLoading
  };
};

export default useFixedItineraryPeriodicHikeSubmit;
